@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.container {
  border-radius: 2px;
  display: flex;
  margin-bottom: 24px;
  padding: 12px;

  & > :first-child {
    margin-right: 12px;
    margin-top: 4px;
    opacity: 1;
  }

  svg {
    height: 18px;
    width: 18px;
  }

  &Error {
    background-color: rgba(map.get(core.$fonts, error), 0.1);
    color: map.get(core.$fonts, error);
  }
  &Message {
    line-height: 24px;
    width: fit-content;
    word-break: break-all;

    &Link {
      line-height: 24px;
      margin-left: 6px;
      text-decoration: underline;

      & a {
        color: map.get(core.$fonts, error);
      }
    }
  }
}
